import {createFileRoute} from '@tanstack/react-router';
import LeaguesView from '../../../../leagues/LeaguesView.tsx';

export const Route = createFileRoute('/_app/cricket/leagues/$league_uid')({
    component: RouteComponent,
})

function RouteComponent() {
    return <LeaguesView />
}
